import React, { useState } from 'react';
import { CardWrapper } from 'admin/components/wrappers';
import CustomDataGrid from 'app/components/CustomDataGrid/Index';
import styled from 'styled-components';
import { CardSubWrapper } from 'admin/components/wrappers';
import { CustomDeletePopup } from 'app/components/CustomDeletePopup';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { MoreIconCell } from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/MoreIconCell';
import TeamNameLabelCell from 'admin/pages/TeamIndividual/components/TeamRiderListing/Cells/TeamNameLabelCell';
import { useNavigate } from 'react-router-dom';
import { PermissionList } from 'services/openapi';
import { usePermission } from 'hooks/usePermission';

interface TeamRiderProps {
  data: PermissionList[];
  loading?: boolean;
  debounceTeamSearch: string;
  handleDeleteRole: (roleId: string) => void;
}
const RoleTable = ({ data, loading, handleDeleteRole }: TeamRiderProps) => {
  const navigate = useNavigate();
  const { hasViewPermission } = usePermission();
  const [showDeletePopup, setShowDeletePopup] = React.useState<boolean>(false);
  const dropDowndata = ['Edit Role Info', 'Delete Role'];
  const [roleId, setRoleId] = useState<string>('');
  const onDataClick = (data: any) => { };
  const handleMoreClick = (item: string, e) => {
    setRoleId(e.dataItem.roleId);
    if (item === 'Edit Role Info') {
      if (hasViewPermission('0900101009')) {
        navigate(`/admin/settings/roles/edit-role/${e.dataItem.roleId}`);
      }
    } else {
      if (hasViewPermission('0900101010')) {
        setShowDeletePopup(true);
      }
    }
  };
  const roleWithSlNo = data.map((rider, index) => ({
    ...rider,
    slNo: index + 1,
  }));

  const tableData = [
    {
      field: 'slNo',
      title: 'Sl.No',
      cell: e => <TeamNameLabelCell e={e} value={e.dataItem.slNo} />,
      width: '130',
    },
    {
      field: 'role',
      title: 'Role',
      cell: e => <TeamNameLabelCell e={e} value={e.dataItem.name} />,
      width: '250',
    },
    {
      field: '',
      title: 'Actions',
      cell: e => (
        <MoreIconCell
          customDropdownData={dropDowndata}
          onDataClick={onDataClick}
          onMoreClick={handleMoreClick}
          e={e}
        />
      ),
      width: '100',
    },
  ];

  const handleDeleteTeamRider = () => {
    handleDeleteRole(roleId);
    setShowDeletePopup(false);
  };

  return (
    <CardWrapper style={{ paddingTop: '15px', width: '100%' }}>
      <CardSubWrapper className="d-flex"></CardSubWrapper>
      <GridWrapper>
        {loading ? (
          <TableSkeletonLoader rowContent={8} width={100} headingWidth={80} />
        ) : (
          <CustomDataGrid data={roleWithSlNo ?? []} columns={tableData} />
        )}
        <CustomDeletePopup
          deleteIcon={true}
          headerUnderline={false}
          popupSubLabel="Are you sure you want to delete this role?"
          className="body-scroll-lock height-full delete-update"
          popupLabel="Delete Role"
          setVisible={setShowDeletePopup}
          visible={showDeletePopup}
          align="centre"
          btnLabel1="Cancel"
          btnLabel2="Delete"
          handlebtn2Click={handleDeleteTeamRider}
          handlebtn1Click={() => {
            setShowDeletePopup(false);
          }}
        />
      </GridWrapper>
    </CardWrapper>
  );
};
const GridWrapper = styled.div`
  .k-grid {
    .k-grid-header {
      border-left: 0.5px solid #caced8;
      border-right: 0.5px solid #caced8;
      border-top: unset;
    }
  }
  .k-table-thead {
    .k-table-row {
      border: 0.5px solid #caced8;
      background-color: #f8f9fa !important;
      th {
        border-top: 0.5px solid #caced8;
      }
    }
  }
  .k-header > .k-cell-inner {
    margin: -0.8rem -0.5rem;
    > .k-link {
      padding: 8px 25px !important;
      font-size: 12px !important;
    }
  }
  .k-grid-container .k-grid-content {
    overflow-y: unset !important;
    overflow: auto;
    height: calc(100vh - 285px);
    border: 0.5px solid #caced8 !important;

    tr td {
      padding: 13px 25px !important;
      border-bottom: 0.5px solid #caced8 !important;
      font-size: 12px !important;
      font-weight: 400 !important ;
      .label-wrapper {
        font-size: 12px !important;
        font-weight: 400 !important ;
      }
    }
    tr:last-child td {
      border-bottom: none !important;
    }
    .k-grid,
    .k-grid-table-wrap .k-grid-table {
      border-bottom: 0.5px solid #caced8 !important;
    }
  }

  .k-grid-content tr {
    &:hover {
      td {
        background: #f0f0f0 !important;
      }
    }
  }
  .k-grid-content tr td {
    cursor: pointer;
  }
`;
export default RoleTable;
